import * as React from 'react'
import Button from '@eversports/klimt-primitives/Button'
import SeoLink from '@eversports/klimt-primitives/SeoLink'
import Text from '@eversports/klimt-primitives/Text'

import { Localized } from '../../localization/react'

import { AuthRoutes } from './UserMenu/UserMenu.constants'

interface Props {
  authUrlParams: string
}

const RegisterButton = ({ authUrlParams }: Props) => (
  <SeoLink
    type="crawler"
    encodedTo={btoa(`${AuthRoutes.REGISTER}${authUrlParams}`)}
    crawlerLink={AuthRoutes.REGISTER}
    external
  >
    <Button variant="primary" sx={{ flex: 1 }}>
      <Text variant="small" sx={{ fontWeight: 'bold', color: 'white', textTransform: 'none' }}>
        <Localized id="user-menu-item-register" />
      </Text>
    </Button>
  </SeoLink>
)

export default RegisterButton
